import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {interval, Subject, take, takeUntil} from "rxjs";
import {MatIcon} from "@angular/material/icon";
import {FeatModule, getFeatureMap} from "../../../../features/admin/components/feat-mgmt/feat-mgmt.types";
import {NgForOf, NgIf} from "@angular/common";
import {fuseAnimations} from "../../../../../@fuse/animations";
import {SMM_VER_DATA} from "../../../../core/types/version.types";

@Component({
    /** CHANGE SELECTOR NAME HERE **/
    selector     : 'feature-show-off-component',
    /** CHANGE TEMPLATE NAME NAME HERE **/
    templateUrl  : './feature-show-off-component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations   : fuseAnimations,
    standalone   : true,
    imports: [
        MatIcon,
        NgForOf,
        NgIf
    ],
})
export class FeatureShowOffComponent implements OnChanges, OnInit, OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    allModules: FeatModule [] = [];
    selectedModule: FeatModule;
    showCreatedBy: boolean = true;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.settings?.currentValue) {

        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    ngOnInit(): void {

        // Toggle "Creata de" and "Folosita de" every 3 seconds
        interval(3000)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.showCreatedBy = !this.showCreatedBy;
                this._changeDetectorRef.markForCheck();
            });

        const allModulesMap: Map<string, FeatModule> = getFeatureMap();
        const modulesArray = Array.from(allModulesMap.values());

        // interval(50)
        //     .pipe(
        //         take(modulesArray.length),
        //         takeUntil(this._unsubscribeAll)
        //     )
        //     .subscribe((index) => {
        //         this.allModules.push(modulesArray[index]);
        //         this._changeDetectorRef.markForCheck();
        //     });

        //initial setting
        let index = 0;
        this.selectedModule = modulesArray[index];
        this._changeDetectorRef.markForCheck();

        if (modulesArray.length > 0) {
            interval(5000)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {
                    index = (index + 1) % modulesArray.length;
                    this.selectedModule = modulesArray[index];
                    this._changeDetectorRef.markForCheck();
                    interval(4500)
                        .pipe(take(1))
                        .subscribe(() => {
                            this.selectedModule = null;
                            this._changeDetectorRef.markForCheck();
                        });
                });
        }


    }

    protected readonly SMM_VER_DATA = SMM_VER_DATA;
}
